import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function AboutPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-6 pb-12">
        <div className="w-full px-4 md:px-6 lg:px-8 max-w-3xl mx-auto">
          <nav className="text-sm text-stone-500 mb-6">
            <a href="/" className="hover:text-emerald-700 transition-colors">{t('breadcrumb_home')}</a>
            <span className="mx-2">/</span>
            <span className="text-stone-700">About</span>
          </nav>

          <h1 className="text-3xl md:text-4xl font-bold text-stone-800 mb-6">About CSSBuyBR</h1>

          <div className="prose prose-stone max-w-none">
            <p className="text-sm md:text-base text-stone-600 leading-relaxed mb-4">
              CSSBuyBR is an independent resource website created to help buyers research products and navigate the CSSBuy Spreadsheet more effectively. We are not affiliated with, endorsed by, or officially representing CSSBuy or any other platform.
            </p>
            <p className="text-sm md:text-base text-stone-600 leading-relaxed mb-4">
              Our goal is to provide organized, practical information that helps users make informed decisions when researching products. We cover topics including product categories, shipping guides, quality control information, safety tips, and general buying advice.
            </p>
            <p className="text-sm md:text-base text-stone-600 leading-relaxed mb-4">
              All content on this website is for informational purposes only. We do not sell products, process payments, or handle any transactions. We simply provide guides and resources to help with the research process.
            </p>

            <h2 className="text-xl md:text-2xl font-bold text-stone-800 mt-8 mb-4">Our Approach</h2>
            <p className="text-sm md:text-base text-stone-600 leading-relaxed mb-4">
              We believe in transparency and accuracy. When we publish guides, we aim to provide practical, actionable information that is genuinely useful. We regularly review our content to ensure it remains relevant and accurate, though we always recommend that users verify current information independently before making any purchase.
            </p>
            <p className="text-sm md:text-base text-stone-600 leading-relaxed mb-4">
              This website is available in three languages: Portuguese, German, and English, to serve a broader audience of international buyers.
            </p>

            <h2 className="text-xl md:text-2xl font-bold text-stone-800 mt-8 mb-4">Important Disclaimer</h2>
            <p className="text-sm md:text-base text-stone-600 leading-relaxed mb-4">
              This is an independent resource. Information about prices, products, sellers, QC, shipping, coupons, and availability may change. Always verify current data before placing any order or payment. We are not responsible for any transactions or purchases you make through third-party platforms.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}